import conversation from "./conversation";
import call from "./call";
import notifications from "./notifications";
import cobrowse from "./cobrowse";
import sketch from "./sketch";
import displayCapture from "./displayCapture";

import { combineReducers } from "redux";

export const rootReducer = combineReducers({
  conversation,
  call,
  notifications,
  cobrowse,
  sketch,
  displayCapture,
});

export default rootReducer;
